import { render, staticRenderFns } from "./DonatorForm.vue?vue&type=template&id=a3a0a634&"
import script from "./DonatorForm.vue?vue&type=script&lang=js&"
export * from "./DonatorForm.vue?vue&type=script&lang=js&"
import style0 from "./DonatorForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DonatorForm.vue"
export default component.exports